import { render, staticRenderFns } from "./customersetting.vue?vue&type=template&id=5290b6fa&scoped=true&"
import script from "./customersetting.vue?vue&type=script&lang=js&"
export * from "./customersetting.vue?vue&type=script&lang=js&"
import style0 from "./customersetting.vue?vue&type=style&index=0&id=5290b6fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5290b6fa",
  null
  
)

export default component.exports